import React, { useState } from 'react';

const BannerImage = ({ data }) => {
  const [value, setValue] = useState(data?.rating_average);
  // Hide the banner entirely if the cover photo fails to load
  const [bannerFailed, setBannerFailed] = useState(false);
  if (bannerFailed) {
    return null;
  }
  return (
    <div className="h-[140px] w-full bg-slate-100 sm:h-[170px] md:h-[190px] lg:h-[230px] xl:h-[285px] 2xl:h-[340px]">
      {data?.cover_photo_url === null && data?.cover_photo_url === '' ? (
        <div className="flex h-full w-full items-center justify-center text-sm text-slate-400">
          Add image from dashboard settings to display here
        </div>
      ) : (
        <img
          className="h-full w-full object-cover"
          src={data.cover_photo_url}
          onError={() => setBannerFailed(true)}
          // style={{
          //   height: '100%',
          //   width: '100%' ,
          //   // backgroundColor: bgColor, 
          //   backgroundImage: `url(${data.cover_photo_url})`,
          //   backgroundRepeat: 'no-repeat',
          //   backgroundSize: '100% 100%',
          //   backgroundPosition: 'center center',
          // }}
          alt="banner"
        />
      )}        
    </div>      
  );
};

export default BannerImage;
